import "vant/es/action-sheet/style";
import _ActionSheet from "vant/es/action-sheet";
import "vant/es/dropdown-item/style";
import _DropdownItem from "vant/es/dropdown-item";
import "vant/es/dropdown-menu/style";
import _DropdownMenu from "vant/es/dropdown-menu";
import "vant/es/swipe-cell/style";
import _SwipeCell from "vant/es/swipe-cell";
import "vant/es/cell/style";
import _Cell from "vant/es/cell";
import "vant/es/list/style";
import _List from "vant/es/list";
import "vant/es/uploader/style";
import _Uploader from "vant/es/uploader";
import "vant/es/field/style";
import _Field from "vant/es/field";
import "vant/es/pull-refresh/style";
import _PullRefresh from "vant/es/pull-refresh";
import "vant/es/swipe-item/style";
import _SwipeItem from "vant/es/swipe-item";
import "vant/es/swipe/style";
import _Swipe from "vant/es/swipe";
import "vant/es/tabs/style";
import _Tabs from "vant/es/tabs";
import "vant/es/tab/style";
import _Tab from "vant/es/tab";
import "vant/es/checkbox-group/style";
import _CheckboxGroup from "vant/es/checkbox-group";
import "vant/es/checkbox/style";
import _Checkbox from "vant/es/checkbox";
import "vant/es/number-keyboard/style";
import _NumberKeyboard from "vant/es/number-keyboard";
import "vant/es/nav-bar/style";
import _NavBar from "vant/es/nav-bar";
import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/datetime-picker/style";
import _DatetimePicker from "vant/es/datetime-picker";
import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "vant/es/search/style";
import _Search from "vant/es/search";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "vant/es/picker/style";
import _Picker from "vant/es/picker";
import "vant/es/radio/style";
import _Radio from "vant/es/radio";
import "vant/es/radio-group/style";
import _RadioGroup from "vant/es/radio-group";
import "vant/es/image/style";
import _Image from "vant/es/image";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/tag/style";
import _Tag from "vant/es/tag";
import "vant/es/locale/style";
import _Locale from "vant/es/locale";
import "D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.json.stringify.js";
// 兼容 IE
// https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md#babelpolyfill
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import instance from './utils/request';
import Bridge from './utils/bridge.js';
import './utils/request.js';
import longPress from './utils/longPress.js';
import '@/assets/css/font.scss';
import componentsRegister from '@/components/global.js'; // 一劳永逸的组件注册
componentsRegister.install();
import vueLazyload from 'vue-lazyload';
import loading from '@/assets/images/img-loading.gif';
import 'font-awesome/css/font-awesome.css';
import Vue2Editor from 'vue2-editor';
import Vconsole from 'vconsole';
import { userCheck, userInfo, userRegister, myCategories, updateInfo } from '@/api/mg';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';
console.log(locale, 'locale');
Vue.use(ElementUI, {
  locale: locale
});

/**
 * 引入i18n国际化
 */
import i18n from './i18n/';
Vue.use(Vue2Editor);
import { baseApi } from '@/config';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
_Locale.use('en-US', enUS);

// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: 'AIzaSyCARMWFJYikmj4azyghdTEYlcxaxsYdahA',
  authDomain: 'soimt-mobile-mgsns-js.firebaseapp.com',
  projectId: 'soimt-mobile-mgsns-js',
  storageBucket: 'soimt-mobile-mgsns-js.appspot.com',
  messagingSenderId: '398334253444',
  appId: '1:398334253444:web:7b174337644c8bb167e5d1',
  measurementId: 'G-1W16GXCD3C'
};

// Initialize Firebase
var firebaseApp = initializeApp(firebaseConfig);
var analytics = getAnalytics(firebaseApp);
Vue.prototype.$analytics = analytics;
localStorage.removeItem('bottomBarIndex');
localStorage.removeItem('activeName');
localStorage.removeItem('socialToken');
localStorage.removeItem('userId');
localStorage.removeItem('pid');
localStorage.removeItem('nickname');
// localStorage.clear()

function getToken() {
  return localStorage.getItem('socialToken');
}
Vue.directive('longpress', longPress);
Vue.use(vueLazyload, {
  loading: loading
});
Vue.prototype.$bridge = Bridge;
Vue.prototype.$http = instance;
new Vconsole();

// 设置 js中可以访问 $cdn
import { $cdn } from '@/config';
Vue.prototype.$cdn = $cdn;

// // 全局引入按需引入UI库 vant
// import '@/plugins/vant'
// // 引入全局样式
// import '@/assets/css/index.scss'
// 移动端适配
import 'lib-flexible/flexible.js';
import VueHtml5Editor from 'vue-html5-editor';
var option = {
  // 全局组件名称，使用new VueHtml5Editor(options)时该选项无效
  // global component name
  name: 'vue-html5-editor',
  // 是否显示模块名称，开启的话会在工具栏的图标后台直接显示名称
  // if set true,will append module name to toolbar after icon
  showModuleName: false,
  // 自定义各个图标的class，默认使用的是font-awesome提供的图标
  // custom icon class of built-in modules,default using font-awesome
  icons: {
    text: 'fa fa-pencil',
    color: 'fa fa-paint-brush',
    font: 'fa fa-font',
    align: 'fa fa-align-justify',
    list: 'fa fa-list',
    link: 'fa fa-chain',
    unlink: 'fa fa-chain-broken',
    tabulation: 'fa fa-table',
    image: 'fa fa-file-image-o',
    hr: 'fa fa-minus',
    eraser: 'fa fa-eraser',
    undo: 'fa-undo fa',
    'full-screen': 'fa fa-arrows-alt',
    info: 'fa fa-info'
  },
  // 配置图片模块
  // config image module
  image: {
    // 文件最大体积，单位字节  max file size
    sizeLimit: 512 * 1024 * 1024,
    // 上传参数,默认把图片转为base64而不上传
    // upload config,default null and convert image to base64
    upload: {
      url: baseApi + '/apiv3/attachments',
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      params: {},
      fieldName: 'file'
    },
    // 压缩参数,默认使用localResizeIMG进行压缩,设置为null禁止压缩
    // compression config,default resize image by localResizeIMG (https://github.com/think2011/localResizeIMG)
    // set null to disable compression
    // compress: {
    //   width: 1600,
    //   height: 1600,
    //   quality: 80
    // },
    compress: null,
    // 响应数据处理,最终返回图片链接
    // handle response data，return image url
    uploadHandler: function uploadHandler(responseText) {
      console.log(responseText, 'responseText');
      // default accept json data like  {ok:false,msg:"unexpected"} or {ok:true,data:"image url"}
      var res = JSON.parse(responseText);
      if (res.Code === 0) {
        return res.Data.url;
      } else {
        Toast(res.Message);
      }
      // if (!json.ok) {
      //   alert(json.msg)
      // } else {
      //   return json.data
      // }
    }
  },

  // 语言，内建的有英文（en-us）和中文（zh-cn）
  // default en-us, en-us and zh-cn are built-in
  // language: 'zh-cn',
  // // 自定义语言
  // i18n: {
  //   // specify your language here
  //   'zh-cn': {
  //     'image': '图片',
  //     'align': '对齐方式',
  //     'list': '列表',
  //     'link': '链接',
  //     'unlink': '去除链接',
  //     'table': '表格',
  //     'font': '文字',
  //     'full screen': '全屏',
  //     'text': '排版',
  //     'eraser': '格式清除',
  //     'info': '关于',
  //     'color': '颜色',
  //     'please enter a url': '请输入地址',
  //     'create link': '创建链接',
  //     'bold': '加粗',
  //     'italic': '倾斜',
  //     'underline': '下划线',
  //     'strike through': '删除线',
  //     'subscript': '上标',
  //     'superscript': '下标',
  //     'heading': '标题',
  //     'font name': '字体',
  //     'font size': '文字大小',
  //     'left justify': '左对齐',
  //     'center justify': '居中',
  //     'right justify': '右对齐',
  //     'ordered list': '有序列表',
  //     'unordered list': '无序列表',
  //     'fore color': '前景色',
  //     'background color': '背景色',
  //     'row count': '行数',
  //     'column count': '列数',
  //     'save': '确定',
  //     'upload': '上传',
  //     'progress': '进度',
  //     'unknown': '未知',
  //     'please wait': '请稍等',
  //     'error': '错误',
  //     'abort': '中断',
  // 'reset': '重置'
  //   }
  // },
  // 隐藏不想要显示出来的模块
  // the modules you don't want
  hiddenModules: [],
  // 自定义要显示的模块，并控制顺序
  // keep only the modules you want and customize the order.
  // can be used with hiddenModules together
  visibleModules: ['image', 'text', 'color', 'font', 'align',
  // 'list',
  // 'link',
  // 'unlink',
  // 'tabulation',
  // 'hr',
  // 'eraser',
  'undo'
  // 'full-screen',
  // 'info'
  ],

  // 扩展模块，具体可以参考examples或查看源码
  // extended modules
  modules: {
    // omit,reference to source code of build-in modules
  }
};
Vue.use(VueHtml5Editor, option);
Vue.use(_Tag);
Vue.use(_Dialog);
Vue.use(_Image);
Vue.use(_RadioGroup);
Vue.use(_Radio);
Vue.use(_Picker);
Vue.use(_Icon);
Vue.use(_Button);
Vue.use(_Search);
Vue.use(_Popup);
Vue.use(_DatetimePicker);
Vue.use(_Toast);
Vue.use(_Loading);
Vue.use(_NavBar);
Vue.use(_NumberKeyboard);
Vue.use(_Checkbox);
Vue.use(_CheckboxGroup);
Vue.use(_Tab);
Vue.use(_Tabs);
Vue.use(_Swipe);
Vue.use(_SwipeItem);
Vue.use(_PullRefresh);
Vue.use(_Field);
Vue.use(_Uploader);
Vue.use(_List);
Vue.use(_Cell);
Vue.use(_SwipeCell);
Vue.use(_DropdownMenu);
Vue.use(_DropdownItem);
Vue.use(_ActionSheet);

// filters
import './filters';
Vue.config.productionTip = false;
router.beforeEach(function (to, from, next) {
  console.log('前端项目环境:' + process.env.NODE_ENV);
  var u = navigator.userAgent; // 判断手机类型
  // 扫码绿色通道
  if (to.path == '/social/share') {
    next();
  }
  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    if (window.Android) {
      var params = JSON.parse(window.Android.getUserInfo());
      if (params.userPhotoBase64) {
        params.userPhotoBase64 = 'data:img/jpg;base64,' + params.userPhotoBase64;
      }
      localStorage.setItem('appParams', JSON.stringify(params));
      localStorage.setItem('language', JSON.stringify(params.language));
      // console.log('Android =》 userInfo: ' + JSON.stringify(params))
      console.log('FROM android APP uid:' + params.uid + ' FROM APP token:' + params.token);
      if (params && params.uid && params.token && !localStorage.getItem('socialToken')) {
        var registerParams = {
          mobilePhone: params.mobilePhone,
          nickname: params.nickname || localStorage.getItem('nickname'),
          avatar: params.avatar,
          uuid: params.uid,
          isOwner: params.isOwner || localStorage.getItem('isOwner')
        };
        console.log('android app=>社交授权登录开始.....');
        // app用户授权登录
        userRegister(registerParams).then(function (res) {
          if (res.Code === 0) {
            localStorage.setItem('socialToken', res.Data.accessToken);
            store.state.socialToken = res.Data.accessToken;
            // 获取用户信息
            userInfo({
              pid: res.Data.uid
            }).then(function (res) {
              if (res.Code === 0) {
                localStorage.setItem('userId', res.Data.id);
                localStorage.setItem('pid', res.Data.group.pid);
                next();
              } else {
                console.log(res.message);
              }
            });
          } else {
            console.log(res.message);
          }
        });
      } else {
        next();
      }
    }
  } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
    Bridge.callhandler('getUserInfo', null, function (res) {
      var params = res;
      if (params.userPhotoBase64) {
        params.userPhotoBase64 = 'data:image/jpeg;base64,' + params.userPhotoBase64;
      }
      localStorage.setItem('appParams', JSON.stringify(params));
      localStorage.setItem('language', JSON.stringify(params.language));
      // this.$i18n.locale = JSON.stringify(params.language);
      // console.log('IOS =》 userInfo: ' + JSON.stringify(params))
      console.log('FROM IOS APP uid:' + params.uid + ' FROM APP token:' + params.token);
      if (params && params.uid && params.token && !localStorage.getItem('socialToken')) {
        var _registerParams = {
          mobilePhone: params.mobilePhone,
          nickname: params.nickname || localStorage.getItem('nickname'),
          avatar: params.avatar,
          uuid: params.uid,
          isOwner: params.isOwner || localStorage.getItem('isOwner')
        };
        console.log('ios app=>社交授权登录开始.....');
        // app用户授权登录
        userRegister(_registerParams).then(function (res) {
          if (res.Code === 0) {
            localStorage.setItem('socialToken', res.Data.accessToken);
            store.state.socialToken = res.Data.accessToken;
            // 获取用户信息
            userInfo({
              pid: res.Data.uid
            }).then(function (res) {
              if (res.Code === 0) {
                localStorage.setItem('userId', res.Data.id);
                localStorage.setItem('pid', res.Data.group.pid);
                next();
              } else {
                console.log(res.message);
              }
            });
          } else {
            console.log(res.message);
          }
        });
      } else {
        next();
      }
    });
  }
  next();
});
router.beforeResolve(function (to, from, next) {
  // 在 2.5.0+ 你可以用 router.beforeResolve 注册一个全局守卫。这和 router.beforeEach 类似，区别是在导航被确认之前，同时在所有组件内守卫和异步路由组件被解析之后，解析守卫就被调用。
  // console.log('beforeResolve')
  next();
});
router.afterEach(function (to, from) {
  // console.log('afterEach')
});
new Vue({
  el: '#app',
  router: router,
  i18n: i18n,
  store: store,
  render: function render(h) {
    return h(App);
  },
  mounted: function mounted() {
    // document.dispatchEvent(new Event('render-event'))
    document.dispatchEvent(new Event('custom-render-trigger'));
  }
});